var map = {
	"./active-skill-star.svg": "0785",
	"./bad-skill-star.svg": "bbf8",
	"./base-active-skill-star.svg": "9800",
	"./base-skill-star.svg": "4ae6",
	"./inactive-skill-star.svg": "f330",
	"./remove-skill-star.svg": "dbce"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "5b30";